require('./brokerTransferValuesTableRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { RadioButton } = require('commonsComponents/radioButton');
// @ components
const { LabelDate } = require('commonsComponents/labelDate');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ consntans
const { BROKER_TRANSFER_VALUES_TYPE_PARTIAL, HYPHEN, BROKER_TYPE_STOCKS_NEW_DECIMALS } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
// @helpers
const { getLanguage, formatText } = require('core/i18n').i18n;

class BrokerTransferValuesTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.onBlur = this.onBlur.bind(this);
        this.handleValueCheck = this.handleValueCheck.bind(this);
    }

    componentDidMount() {
        if (this.props.onlyRowSelected) {
            this.handleValueCheck();
        }
    }

    onBlur(titles) {
        const { immValue, setTitlesValue } = this.props;

        setTitlesValue(immValue.get('id'), titles);
    }

    handleValueCheck() {
        const { toggleCheckValue, immValue } = this.props;
        toggleCheckValue(immValue.get('id'));
    }

    render() {
        const { immValue, immTransferValues, selectable } = this.props;
        const id = `checkboxValues${immValue.get('id')}`;
        const price = immValue.get('price').set('decimalsLength', BROKER_TYPE_STOCKS_NEW_DECIMALS);
        const valueId = immValue.get('id');
        const priceObject = formatAmountObject(price);
        const formattedPrice = `${priceObject.amount} ${priceObject.currencyCode}`;
        const availableTitles = immValue.get('titles');
        const titles = immTransferValues.getIn(['steps', 1, 'titles', valueId]) || 0;
        const validStep = immTransferValues.getIn(['steps', 1, 'valid']);
        const checked = immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'id']) === valueId;
        const plainAmountObject = getPlainAmountObject(immValue.get('value'));
        const language = getLanguage();
        const currentValueId = immValue.get('id');
        const selectedId = immTransferValues.getIn(['steps', 1, 'partial', 'id']);
        let selectionRadio, titlesAmountToTransfer;

        if (selectable) {
            selectionRadio = (
                <RadioButton
                    id={id}
                    name="partialTransferValues"
                    onChange={this.handleValueCheck}
                    value={immValue.get('id')}
                    isChecked={checked}
                    className="broker-transfer-values-table-row"
                />
            );

            titlesAmountToTransfer = (
                <AmountInput
                    type="text"
                    name={id}
                    amount={titles}
                    callback={this.onBlur}
                    max={availableTitles}
                    min={0}
                    maxFractionLength={0}
                    maxBackEndFractionLength={0}
                    fluid={true}
                    error={checked && !validStep}
                    language={language}
                    disabled={selectedId !== currentValueId}
                />
            );
        } else {
            titlesAmountToTransfer = availableTitles;
        }

        const date = immValue.get('date')
            ? (<div>
                <LabelDate
                    date={immValue.get('date')}
                    language={language}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            </div>)
            : HYPHEN;

        return (
            <OKTableRow>
                <OKTableCell>
                    <div className="broker-transfer-values-table__checkbox-container">
                        {selectionRadio}
                    </div>
                </OKTableCell>
                <OKTableCell>
                    <div className="broker-transfer-values-table__description">{immValue.get('description')}</div>
                    {formatText(`transferValues-${immValue.get('type')}`)}
                </OKTableCell>
                <OKTableCell className="broker-transfer-values-table__cell-short">
                    {formattedPrice}
                    <div>
                        {date}
                    </div>
                </OKTableCell>
                <OKTableCell className="broker-transfer-values-table__cell-short">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell className="broker-transfer-values-table__cell-short">
                    {immValue.get('titles')}
                </OKTableCell>
                <OKTableCell className="broker-transfer-values-table__cell-short">
                    {titlesAmountToTransfer}
                </OKTableCell>
            </OKTableRow>
        );
    }
}

BrokerTransferValuesTableRow.propTypes = {
    immValue: PropTypes.object.isRequired,
    immTransferValues: PropTypes.object.isRequired,
    setTitlesValue: PropTypes.func.isRequired,
    toggleCheckValue: PropTypes.func.isRequired,
    onlyRowSelected: PropTypes.bool,
    selectable: PropTypes.bool
};

module.exports = BrokerTransferValuesTableRow;
